import React from 'react';

const HowDoesItWorkQuickerJobVector = ({ ...props }) => (
  <svg
    width="376"
    height="412"
    viewBox="0 0 376 412"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M375.54 344.106C375.54 348.168 374.739 352.191 373.182 355.944C371.625 359.697 369.344 363.107 366.468 365.979C363.591 368.852 360.177 371.13 356.419 372.685C352.661 374.239 348.633 375.039 344.565 375.039H336.426V404.267C336.426 406.318 335.611 408.285 334.158 409.735C332.706 411.185 330.737 412 328.683 412H50.8948C48.841 412 46.8714 411.185 45.4192 409.735C43.967 408.285 43.1512 406.318 43.1512 404.267V375.039H30.9744C22.7595 375.039 14.881 371.78 9.07216 365.979C3.26334 360.178 0 352.31 0 344.106V115.999C0 85.2344 12.2376 55.7295 34.0207 33.9754C55.8038 12.2213 85.348 0 116.154 0H259.386C290.192 0 319.736 12.2213 341.519 33.9754C363.302 55.7295 375.54 85.2344 375.54 115.999V344.106Z"
      fill="#941535"
    />
  </svg>
);

export default HowDoesItWorkQuickerJobVector;
